import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lean-step-help',
  templateUrl: './lean-step-help.component.html',
  styleUrls: ['./lean-step-help.component.scss']
})
export class LeanStepHelpComponent implements OnInit {

  @Input() helpLines : string[];

  constructor() { }

  ngOnInit() {
  }

}
